<template>
  <div class="qyxxbgDiaLogBody">
    <div class="_title" style="width: 190px">
      <p class="_title_info" style="margin: 0 auto">法人/经营者信息变更</p>
    </div>
    <div v-if="idCard == '1'" class="uploadImage">
      <div class="left">
        <div class="uploadLeftContainer" style="">
          <el-upload
            :action="returnSaveFile"
            class="avatar-uploader"
            :data="{ sbzjlx: 'sfzZm' }"
            :show-file-list="false"
            :on-success="handleFaceAvatarScuccess"
            :on-preview="handlePictureCardPreview"
            :headers="token"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="imageUrlOface"
              :src="imageUrlOface"
              style="width: 204px; height: 140px"
              class="avatar"
            >
            <img
              v-else
              class="vatar-uploader-icon"
              src="@/assets/img/zjrlx.png"
            >
          </el-upload>
          <div
            v-preventReClick
            class="deleteUpload"
            @click="removeCurImg('rl')"
          >
            <i v-show="isShowLeftDelete" class="el-icon-circle-close" />
          </div>
        </div>
        <div class="instruction" style="text-align: center">证件人像面</div>
      </div>
      <div class="right">
        <div class="uploadRightContainer">
          <el-upload
            class="avatar-uploader"
            :action="returnSaveFile"
            :data="{ sbzjlx: 'sfzFm' }"
            :show-file-list="false"
            :on-success="handleZGAvatarScuccess"
            :on-preview="handlePictureCardBacPreview"
            :headers="token"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="imageUrlOfZG"
              :src="imageUrlOfZG"
              style="width: 204px; height: 140px"
              class="avatar"
            >
            <img
              v-else
              class="vatar-uploader-icon"
              src="@/assets/img/zjghx.png"
            >
          </el-upload>
          <div
            v-preventReClick
            class="deleteUpload"
            style=""
            @click="removeCurImg('gh')"
          >
            <i v-show="isShowRightDelete" class="el-icon-circle-close" />
          </div>
        </div>

        <div class="instruction" style="text-align: center">证件国徽面</div>
      </div>
    </div>
    <div v-if="idCard == '4'" class="uploadImage">
      <div class="left">
        <div class="uploadLeftContainer" style="">
          <el-upload
            :action="returnSaveFile"
            class="avatar-uploader"
            :data="{ sbzjlx: 'sfzZm' }"
            :show-file-list="false"
            :on-success="handleFaceAvatarScuccess"
            :on-preview="handlePictureCardPreview"
            :headers="token"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="imageUrlOface"
              :src="imageUrlOface"
              style="width: 204px; height: 140px"
              class="avatar"
            >
            <img
              v-else
              class="vatar-uploader-icon"
              src="@/assets/img/zjrlx.png"
            >
          </el-upload>
          <div
            v-preventReClick
            class="deleteUpload"
            @click="removeCurImg('rl')"
          >
            <i v-show="isShowLeftDelete" class="el-icon-circle-close" />
          </div>
        </div>
        <div class="instruction" style="text-align: center">证件人像面</div>
      </div>
    </div>
    <div class="_sfzjInfo">
      <div class="_sfzjTitle">身份证件信息</div>
      <div class="_sfzjBd">
        <el-form
          ref="FrForm1"
          :rules="rules"
          label-position="right"
          class="_sfzjForm"
          label-width="140px"
          :model="frBgjlDtoFu"
        >
          <el-form-item label="姓名:" prop="xm">
            <el-input
              v-model="frBgjlDtoFu.xm"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="证件类型:">
            <el-select
              v-model="frBgjlDtoFu.zjlx"
              style="width: 100%"
              placeholder="请选择证件类型"
              @change="zjlxChange"
            >
              <el-option
                v-for="(item, index) in zjlxList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="idCard == '4'" label="证件名称:" prop="qtzj">
            <el-select v-model="frBgjlDtoFu.qtzj" style="width: 100%">
              <el-option
                v-for="(item, index) in zjNameOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="性别:" prop="xb">
            <el-select
              v-model="frBgjlDtoFu.xb"
              style="width: 100%"
              placeholder="请选择性别"
            >
              <el-option
                v-for="(item, index) in sexOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码:" prop="zjhm">
            <el-input
              v-model="frBgjlDtoFu.zjhm"
              placeholder="请输入证件号码"
            />
          </el-form-item>
          <el-form-item label="民族:" prop="mz">
            <el-select
              v-model="frBgjlDtoFu.mz"
              style="width: 100%"
              placeholder="请选择民族"
            >
              <el-option
                v-for="(item, index) in mzOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期:" prop="sr">
            <el-date-picker
              v-model="frBgjlDtoFu.sr"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择出生日期"
            />
          </el-form-item>
          <el-form-item v-if="idCard == '1'" label="籍贯:">
            <el-cascader
              :key="jgKey"
              v-model="jgNum"
              style="width: 100%"
              placeholder="请选择籍贯"
              clearable
              :props="jgProps"
              @change="jgChange"
            />
          </el-form-item>
          <el-form-item label="有效期限:" prop="yxqxKs">
            <el-date-picker
              v-model="frBgjlDtoFu.yxqxKs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 46%"
              placeholder="选择日期"
            />
            至
            <el-date-picker
              v-model="frBgjlDtoFu.yxqxJs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 48%"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item label="发证机关:" prop="fzjg">
            <el-input
              v-model="frBgjlDtoFu.fzjg"
              placeholder="请输入机关名称"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="_qtxxInfo">
      <div class="_qtxxTitle">其他信息</div>
      <div class="_qtxxBd">
        <el-form
          ref="FrForm2"
          :rules="rules"
          label-position="right"
          class="_qtxxForm"
          label-width="140px"
          :model="frBgjlDtoFu"
        >
          <el-form-item label="办公电话:" prop="bgdh">
            <el-input
              v-model="frBgjlDtoFu.bgdh"
              placeholder="请输入办公电话 例:010-86551122"
            />
          </el-form-item>
          <el-form-item label="手机号码:" prop="sjhm">
            <el-input
              v-model="frBgjlDtoFu.sjhm"
              placeholder="请输入手机号码"
            />
          </el-form-item>
          <el-form-item class="jydItem" label="实际住址:" prop="sjzz">
            <el-input
              v-model="frBgjlDtoFu.sjzz"
              placeholder="请输入实际住址"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getXzqTree,
  getXzqTreeS
} from '@/assets/js/step2.js'
import {
  getkv,
  getToken,
  returnSaveFile,
  returnShowPic
} from '@/assets/js/common.js'
import { lengthValidate } from '@/assets/js/validate.js'
export default {
  props: {
    frBgjlDto: Object
  },
  data() {
    const telphoneValidate = (rule, value, callback) => {
      if (!this.frBgjlDtoFu.sjhm) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const jgjiaoyan = (rule, value, callback) => {
      if (this.jgNum.length == 0) {
        return callback(new Error('请选择行政区划'))
      } else {
        this.jgNum.forEach((element) => {
          if (element == undefined) {
            return callback(new Error('请选择行政区划'))
          }
        })
        callback()
      }
    }
    const yyqxValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择营业期限起始时间'))
      }
      if (!this.frBgjlDtoFu.yxqxJs) {
        return callback(new Error('请选择营业期限结束时间'))
      }
      callback()
    }
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (value) {
        if (!reg1.test(value) && !reg2.test(value)) {
          callback(new Error('请输入正确的电话或手机号格式'))
        }
      }
      callback()
    }
    const validateCard = (rule, value, callback) => {
      if (this.frBgjlDtoFu.zjlx == '1') {
        if (!this.IdentityCodeValid(value)) {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      } else {
        lengthValidate(rule, value, callback, 'bt', 100)
      }
    }
    return {
      // 时间选择器的快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '长期有效',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      // 籍贯懒加载
      jgProps: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 400)
        }
      },
      URL: '',
      // 上传图片携带的token
      token: {
        Authorization: getToken()
      },
      // 证件类型列表
      zjlxList: [
        { label: '身份证', value: '1' },
        { label: '其他证件', value: '4' }
      ],
      returnSaveFile: '', // 返回保存图片的前缀
      // img
      leftimg: '',
      rightimg: '',
      idCard: '1', // 证件类型
      jgKey: 1, // 解决级联选择器渲染
      // 性别KV
      sexOptions: [
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      mzOptions: [], // 民族
      zjNameOptions: [], // 证件名称
      jgNum: [], // 行政区划
      rules: {
        bgdh: [{ validator: phoneValidator, trigger: ['blur', 'change'] }],
        xm: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'change'
          }
        ],
        xb: [{ required: true, message: '请选择性别', trigger: 'change' }],
        zjhm: [{ required: true, validator: validateCard, trigger: 'change' }],
        mz: [{ required: true, message: '请选择民族', trigger: 'change' }],
        sr: [{ required: true, message: '请选择出生日期', trigger: 'change' }],

        jgNum: [{ required: true, validator: jgjiaoyan, trigger: 'change' }],

        yxqxKs: [
          { required: true, validator: yyqxValidator, trigger: 'change' }
        ],
        qtzj: [{ required: true, message: '请选择证件', trigger: 'change' }],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: 'change'
          }
        ],
        sjzz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 600)
            },
            trigger: ['blur', 'change']
          }
        ],
        sjhm: [
          {
            required: true,
            validator: telphoneValidate,
            trigger: 'change',
            min: 11,
            max: 11
          }
        ]
      },
      // 校验规则
      imageUrlOfZG: '', // 证件国徽面
      imageUrlOface: '', // 证件人像面
      isShowLeftDelete: false,
      isShowRightDelete: false,
      dialogTableVisible: false,
      dialogFormVisible: true
    }
  },
  computed: {
    frBgjlDtoFu: {
      get() {
        return this.frBgjlDto
      },
      set(val) {
        this.$emit('getfrBgjlDto', val)
      }
    }
  },
  watch: {
    'frBgjlDtoFu.zjlx'(newValue, oldValue) {
      // 监听证件类型
      this.idCard = newValue
    },
    frBgjlDtoFu(newValue, oldValue) {
      this.jgNum = !newValue.jg ? [] : newValue.jg.split(',').map(Number) // 籍贯回显
      /* 证件照回显 */
      if (newValue.zjzpZm !== '' && newValue.zjzpZm !== null) {
        this.imageUrlOfZG = returnShowPic() + newValue.zjzpFm
        this.imageUrlOface = returnShowPic() + newValue.zjzpZm
      }
    }
  },
  created() {
    this.returnSaveFile = returnSaveFile()
  },
  mounted() {
    // 加载字典项
    this.initFr()
  },
  beforeDestroy() {},
  methods: {
    lengthValidate,
    IdentityCodeValid(code) {
      // 验证身份证合法性
      const city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      let pass = true

      const patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!code || !patt1.test(code)) {
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            pass = false
          }
        }
      }
      return pass
    },
    // 校验 dialog3提交按钮会调用
    validate() {
      var flag1 = false
      var flag2 = false
      this.$refs['FrForm1'].validate((valid) => {
        flag1 = valid
      })
      this.$refs['FrForm2'].validate((valid) => {
        flag2 = valid
      })
      if (!flag1) {
        setTimeout(() => {
          // 如果法人基本信息的校验没通过  将滚动条滑到此处
          var isError = document.getElementsByClassName('is-error')
          isError[0].querySelector('input').focus()
        }, 100)
        return false
      }
      if (!flag2) {
        setTimeout(() => {
          // 如果其他信息的校验没通过  将滚动条滑到此处
          var isError = document.getElementsByClassName('is-error')
          isError[0].querySelector('input').focus()
        }, 100)
        return false
      }
      // 校验照片是否上传
      if (this.frBgjlDtoFu.zjlx == '1') {
        if (this.imageUrlOfZG == '' || this.imageUrlOface == '') {
          this.$message({
            message: '请上传法人/经营者身份证件',
            type: 'warning',
            duration: 10000
          })
          return false
        }
      } else {
        if (this.imageUrlOface == '') {
          this.$message({
            message: '请上传法人/经营者身份证件',
            type: 'warning',
            duration: 10000
          })
          return false
        }
      }
      return flag1 && flag2
    },
    initFr() {
      // 民族
      getkv('yzd_mz').then((e) => {
        this.mzOptions = e.data.data
      })
      // 证件名称
      getkv('yzd_ry_zjmc').then((e) => {
        this.zjNameOptions = e.data.data
      })
    },
    // 人脸面
    handlePictureCardPreview(file) {
      this.imageUrlOface = file.url
    },
    // 国徽面
    handlePictureCardBacPreview(file) {
      this.imageUrlOfZG = file.url
    },
    // 切换籍贯
    jgChange(value) {
      this.frBgjlDtoFu.jg = value.join(',')
    },
    // 删除当前证件照片
    removeCurImg(type) {
      if (type == 'gh') {
        this.imageUrlOfZG = ''
        this.frBgjlDtoFu.zjzpFm = ''
        this.isShowRightDelete = false
      } else if (type == 'rl') {
        this.imageUrlOface = ''
        this.frBgjlDtoFu.zjzpZm = ''
        this.isShowLeftDelete = false
      }
    },
    // 证件人像面
    handleFaceAvatarScuccess(res, file) {
      this.imageUrlOface = URL.createObjectURL(file.raw)
      this.frBgjlDtoFu.zjzpZm = res.data.url
      if (this.imageUrlOface !== '') {
        this.isShowLeftDelete = true
        this.leftimg = res.data.url
        /* if (res.data.ocrFlag) {
          this.$message.success("证件上传成功");
          this.frBgjlDtoFu.mz = res.data.oneData.mz;
          this.frBgjlDtoFu.sjzz = res.data.oneData.sjzz;
          this.frBgjlDtoFu.sr = res.data.oneData.sr;
          this.frBgjlDtoFu.xb = res.data.oneData.xb;
          this.frBgjlDtoFu.xm = res.data.oneData.xm;
          this.frBgjlDtoFu.zjhm = res.data.oneData.zjhm;
        } else {
          this.$message.warning("证件上传成功,但无法识别!请手动填写!");
        }*/
      }
    },
    zjlxChange(val) {
      this.$refs['FrForm1'].clearValidate()
      // 切换证件类型时  其他证件清空第二章证件的数据
      if (val == '4') {
        this.imageUrlOfZG = ''
        this.frBgjlDtoFu.zjzpFm = ''
        this.isShowRightDelete = false
      }
    },
    // 国徽
    handleZGAvatarScuccess(res, file) {
      this.imageUrlOfZG = URL.createObjectURL(file.raw)
      this.frBgjlDtoFu.zjzpFm = res.data.url
      if (this.imageUrlOfZG !== '') {
        this.isShowRightDelete = true
        this.rightimg = res.data.url
        /* if (res.data.ocrFlag) {
          this.$message.success("证件上传成功");
          this.frBgjlDtoFu.fzjg = res.data.oneData.fzjg;
          this.frBgjlDtoFu.yxqxJs = res.data.oneData.yxqxJs;
          this.frBgjlDtoFu.yxqxKs = res.data.oneData.yxqxKs;
        } else {
          this.$message.warning("证件上传成功,但无法识别!请手动填写!");
        }*/
      } else {
        this.$message.error('证件上传失败')
      }
    },
    // 上传之前校验
    beforeAvatarUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 10px auto 0px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    width: 120px;
    margin-top: 50px;
    ._title_info {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }
  .uploadImage {
    margin-top: 50px;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 160px;
    border-radius: 3px;
    box-sizing: border-box;
    .uploadLeftContainer {
      position: relative;
    }
    .uploadRightContainer {
      position: relative;
    }
    .deleteUpload {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 0;
      top: 15px;
      cursor: pointer;
    }
  }
  ._sfzjInfo {
    width: 85%;
    margin-top: 69px;
    ._sfzjTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._sfzjBd {
      margin: 30px 0px;
      ._sfzjForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
  ._qtxxInfo {
    width: 85%;
    ._qtxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._qtxxBd {
      margin: 30px 0px;
      ._qtxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
}
/deep/.el-form-item__label {
  color: #333333;
}
</style>
